import Marquee from "react-fast-marquee";
import { useLang } from "@/context/LanguageContext";

export const RibbonMarquee = () => {
  const { t } = useLang();
  const words = t.marquee;

  return (
    <section data-testid="marquee-section" className="border-y border-line py-6 md:py-8">
      <Marquee speed={40} gradient={false} autoFill>
        {words.map((w, i) => (
          <span key={i} className="flex items-center">
            <span className="heading-serif px-8 text-3xl tracking-[0.15em] text-forest md:text-4xl">
              {w}
            </span>
            <span className="text-xl text-line">✦</span>
          </span>
        ))}
      </Marquee>
    </section>
  );
};
